module.exports = __webpack_public_path__ + "img/sidebar-resources-ico-blue-01.34685a20.svg";